let conectado = false;

export const wsSoporteConectado = () => conectado;

export const marcarWsSoporte = (valor) => {
  if (conectado === valor) return;
  conectado = valor;
  window.dispatchEvent(new CustomEvent("soporte_ws_estado", { detail: { conectado: valor } }));
};
